module.exports = __webpack_public_path__ + "static/media/AFRICAN HOME (1).17c44278.jpg";